module.exports = __webpack_public_path__ + "media/carefree-by-kevin-macleod-from-filmmusic-io-compressed.2891f5f3.mp3";